document.addEventListener('DOMContentLoaded', () => {
  if (is_wcp_wholesale_customer && wcp_customer.tags.length > 0) {
    const intervalId = setInterval(() => {
      const wpd = document.querySelector('.wpd-processed');
      if (wpd) {
        clearInterval(intervalId);
        findPrices();
      }
    }, 100);
  }
})

function findPrices() {
  setTimeout(() => {
    let stickyAtc = document.querySelector('.cf21-price');
    stickyAtc.textContent = '';
    stickyAtc.appendChild(addWpd());

    let mainAtc = document.querySelector('.product-form__actions button[type="submit"]');
    mainAtc.textContent = mainAtc.textContent.replace(/[^a-zA-Z\s-]/g, '');
    mainAtc.appendChild(addWpd());

    checkWpd();
  }, 200);
}

function checkWpd() {
  const wpdCheck = setInterval(() => {
    const atcWpd = document.querySelector('.product-form__actions button[type="submit"] .wpd-processed');
    if (!(atcWpd)) {
      clearInterval(wpdCheck);
      findPrices();
    }
  }, 100);
}

function addWpd() {
  let clonePrice = document.querySelector('.product-form__prices .wpd-processed').cloneNode();
  clonePrice.className = '';
  return clonePrice;
}